import script from "./BackDrop.vue?vue&type=script&setup=true&lang=js"
export * from "./BackDrop.vue?vue&type=script&setup=true&lang=js"

import "./BackDrop.vue?vue&type=style&index=0&id=67d07d46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d07d46"]])

export default __exports__